"use client";

import { useState, useEffect } from "react";
import {
  Search,
  Filter,
  Plus,
  Download,
  Eye,
  MoreHorizontal,
  ChevronLeft,
  ChevronRight,
  TrendingUp,
  Users,
  Calendar,
  DollarSign,
  BarChart3,
} from "lucide-react";
import {
  AreaChart,
  Area,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import {
  BarChart as BarChatWeek,
} from "../../components/facturacion/charts";
import { useMediaQuery } from "react-responsive";

const reportData = [
  {
    id: "558325",
    fechaCompra: "08/6/2025 17:07:18",
    evento: "Viva el Musical",
    cliente: "Renata",
    codigo: "Entrada",
    entrada: "Sector Central",
    fechaFuncion: "sábado 14 de junio de 2025 HORA: 21:00",
    precio: 15500.0,
    cantidad: 1,
    subtotal: 15500.0,
    cupon: "null%",
    descuento: 0,
    total: 15500.0,
    totalServ: 17835.0,
    estado: "ACTIVO",
    datosPago: "ExQbSDpsunV58325",
  },
  {
    id: "558324",
    fechaCompra: "08/6/2025 17:07:43",
    evento: "Viva el Musical",
    cliente: "Andrea Fabiana",
    codigo: "Entrada",
    entrada: "Sector Central",
    fechaFuncion: "sábado 14 de junio de 2025 HORA: 21:00",
    precio: 15500.0,
    cantidad: 1,
    subtotal: 15500.0,
    cupon: "null%",
    descuento: 0,
    total: 15500.0,
    totalServ: 17835.0,
    estado: "ACTIVO",
    datosPago: "ExN5fwJAVTK58324",
  },
  {
    id: "558323",
    fechaCompra: "08/6/2025 17:07:53",
    evento: "LA CHARO presenta Canciones enramadas",
    cliente: "MARIANA ITATI",
    codigo: "Entrada",
    entrada: "Preventa",
    fechaFuncion: "jueves 26 de junio de 2025 HORA: 21:00",
    precio: 17000.0,
    cantidad: 1,
    subtotal: 17000.0,
    cupon: "null%",
    descuento: 0,
    total: 17000.0,
    totalServ: 19550.0,
    estado: "ACTIVO",
    datosPago: "ExfZSRYGwKy58323",
  },
  {
    id: "558322",
    fechaCompra: "08/6/2025 16:07:50",
    evento: "LA CHARO presenta Canciones enramadas",
    cliente: "Angela Ivana de Jesus",
    codigo: "Entrada",
    entrada: "Preventa",
    fechaFuncion: "jueves 26 de junio de 2025 HORA: 21:00",
    precio: 17000.0,
    cantidad: 2,
    subtotal: 34000.0,
    cupon: "0%",
    descuento: 0,
    total: 34000.0,
    totalServ: 39100.0,
    estado: "ACTIVO",
    datosPago: "Exnp09ZQydb58322",
  },
  {
    id: "558321",
    fechaCompra: "08/6/2025 13:07:14",
    evento: "Muerte en el expreso a Edimburgo",
    cliente: "Ana Laura Morales",
    codigo: "Entrada",
    entrada: "Entrada general",
    fechaFuncion: "sábado 21 de junio de 2025 HORA: 21:00",
    precio: 10000.0,
    cantidad: 1,
    subtotal: 10000.0,
    cupon: "0%",
    descuento: 0,
    total: 10000.0,
    totalServ: 11500.0,
    estado: "ACTIVO",
    datosPago: "ExuehSytxep58321",
  },
  {
    id: "558320",
    fechaCompra: "08/6/2025 2:07:26",
    evento: "La Pelada, un crimen en la cañada",
    cliente: "Guillermo Ventor",
    codigo: "Entrada",
    entrada: "general",
    fechaFuncion: "sábado 21 de junio de 2025 HORA: 21:00",
    precio: 12000.0,
    cantidad: 2,
    subtotal: 24000.0,
    cupon: "0%",
    descuento: 0,
    total: 24000.0,
    totalServ: 27600.0,
    estado: "ACTIVO",
    datosPago: "ExbzEDhazQV958320",
  },
];

const Reportes = ({
  filter,
  setFilter,
  fetch,
  data,
  setData,
  onClick,
  onChange,
  provincias,
  navigate,
  user,
  estadisticas,
}) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  const [stats, setStats] = useState({
    totalVentas: 2847650,
    ventasHoy: 156780,
    entradasVendidas: 1247,
    entradasHoy: 67,
    eventosActivos: 12,
    crecimiento: 12.5,
  });

  const [realtimeData, setRealtimeData] = useState([
    { time: "09:00", ventas: 45000, entradas: 12 },
    { time: "10:00", ventas: 52000, entradas: 18 },
    { time: "11:00", ventas: 48000, entradas: 15 },
    { time: "12:00", ventas: 61000, entradas: 22 },
    { time: "13:00", ventas: 55000, entradas: 19 },
    { time: "14:00", ventas: 67000, entradas: 25 },
    { time: "15:00", ventas: 72000, entradas: 28 },
    { time: "16:00", ventas: 58000, entradas: 21 },
    { time: "17:00", ventas: 84000, entradas: 31 },
  ]);

  const [eventStats, setEventStats] = useState([
    {
      name: "Viva el Musical",
      value: 450000,
      entradas: 156,
      color: "#8884d8",
    },
    { name: "La Pelada", value: 220000, entradas: 76, color: "#ff7300" },
    { name: "Otros eventos", value: 180000, entradas: 54, color: "#00ff88" },
  ]);

  const [entryTypeStats] = useState([
    { name: "Sector Central", value: 45, color: "#0088FE" },
    { name: "Preventa", value: 30, color: "#00C49F" },
    { name: "Entrada General", value: 20, color: "#FFBB28" },
    { name: "VIP", value: 5, color: "#FF8042" },
  ]);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  const formatDate = (dateString) => {
    const date = new Date(
      dateString.replace(/(\d{2})\/(\d{1,2})\/(\d{4})/, "$3-$2-$1")
    );
    return date.toLocaleDateString("es-AR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const listarCodigos = (reporte) => {
    if (reporte.cantidad > 1 && reporte.reporte_codigo.length > 0) {
      return (
        <div class="dropdown dropend">
          <button
            class="w-100 btn btn-outline-dark d-block px-1 py-1 mb-1 text-nowrap dropdown-toggle"
            style={{ fontSize: "10px" }}
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Entradas
          </button>
          <ul
            class="dropdown-menu bg-light p-0 border-0"
            aria-labelledby="dropdownMenuButton1"
          >
            {reporte.reporte_codigo.map((codigo) => (
              <label
                className="text-start btn btn-outline-dark d-block px-1 py-1 text-nowrap"
                style={{ fontSize: "10px" }}
              >
                <i class="bi bi-cloud-arrow-down me-2"></i>
                {`${codigo.codigo}`}
                <button
                  className="d-none"
                  name="download-entrada"
                  onClick={(event) =>
                    onClick(event, { reporte: reporte, codigo: codigo.codigo })
                  }
                ></button>
              </label>
            ))}
          </ul>
        </div>
      );
    } else {
      return (
        <div class="dropdown dropend">
          <button
            class="w-100 btn btn-outline-dark d-block px-1 py-1 mb-1 text-nowrap dropdown-toggle"
            style={{ fontSize: "10px" }}
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Entradas
          </button>
          <ul
            class="dropdown-menu bg-light p-0 border-0"
            aria-labelledby="dropdownMenuButton1"
          >
            <label
              className="btn btn-outline-dark d-block px-1 py-1 text-nowrap"
              style={{ fontSize: "10px" }}
            >
              {`${reporte.status} | ${reporte.codigo}`}
              <i class="ms-1 bi bi-ticket"></i>
              <button
                className="d-none"
                name="download-entrada"
                onClick={(event) =>
                  onClick(event, { reporte: reporte, codigo: reporte.codigo })
                }
              ></button>
            </label>
          </ul>
        </div>
      );
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      // Simular nuevas ventas en tiempo real
      setStats((prev) => ({
        ...prev,
        totalVentas: prev.totalVentas + Math.floor(Math.random() * 5000),
        ventasHoy: prev.ventasHoy + Math.floor(Math.random() * 2000),
        entradasVendidas: prev.entradasVendidas + Math.floor(Math.random() * 3),
        entradasHoy: prev.entradasHoy + Math.floor(Math.random() * 2),
      }));

      // Actualizar gráfico en tiempo real
      setRealtimeData((prev) => {
        const newData = [...prev];
        const currentTime = new Date();
        const timeString =
          currentTime.getHours().toString().padStart(2, "0") +
          ":" +
          currentTime.getMinutes().toString().padStart(2, "0");

        if (newData.length >= 10) {
          newData.shift();
        }

        newData.push({
          time: timeString,
          ventas: Math.floor(Math.random() * 40000) + 45000,
          entradas: Math.floor(Math.random() * 20) + 10,
        });

        return newData;
      });
    }, 5000); // Actualizar cada 5 segundos

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="min-vh-100 m-auto bg-gray-50 "
      style={{
        maxWidth: "1500px",
      }}
    >
      {/* Header */}
      <div className="bg-white border-bottom">
        <div className="px-4">
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ height: "64px" }}
          >
            <div className="d-flex align-items-center">
              <h1 className="h2 fw-bold text-dark mb-0 me-3">REPORTES</h1>
              <span className="badge bg-secondary d-none d-sm-inline-flex">
                REPORTES: {data?.total ?? 0}
              </span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <button className="d-none btn btn-outline-primary btn-sm d-none d-sm-inline-flex">
                <Download className="me-2" size={16} />
                Exportar
              </button>
              <button
                className="btn btn-sm"
                style={{ backgroundColor: "#ea580c", color: "white" }}
              >
                <Plus className="me-2" size={16} />
                <span className="d-none d-sm-inline">NUEVO REPORTE</span>
                <span className="d-sm-none">NUEVO</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 py-4">
        {/* Dashboard de Estadísticas */}
        <div className="row g-4 mb-4">
          <div className="col-12 col-md-6 col-lg-3">
            <div className="card h-100">
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <p className="text-muted small mb-1">Total Ventas</p>
                    <p className="h4 fw-bold text-dark mb-0">
                      {formatCurrency(estadisticas["total-ventas"])}
                    </p>
                  </div>
                  <div className="p-3 bg-blue-100 rounded-circle">
                    <DollarSign className="text-blue-600" size={24} />
                  </div>
                </div>
                <div className="mt-3 d-flex align-items-center">
                  <TrendingUp className="text-success me-1" size={16} />
                  <span className="text-success fw-medium small">
                    {estadisticas["porcentaje-mes-ventas"]}%
                  </span>
                  <span className="text-muted small ms-2">vs mes anterior</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <div className="card h-100">
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <p className="text-muted small mb-1">Ventas Hoy</p>
                    <p className="h4 fw-bold text-dark mb-0">
                      {formatCurrency(estadisticas["ventas-hoy"])}
                    </p>
                  </div>
                  <div className="p-3 bg-green-100 rounded-circle">
                    <TrendingUp className="text-green-600" size={24} />
                  </div>
                </div>
                <div className="mt-3 d-flex align-items-center">
                  <div
                    className="rounded-circle bg-success me-2 animate-pulse"
                    style={{ width: "8px", height: "8px" }}
                  ></div>
                  <span className="text-muted small">
                    Actualizando en tiempo real
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <div className="card h-100">
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <p className="text-muted small mb-1">Entradas Vendidas</p>
                    <p className="h4 fw-bold text-dark mb-0">
                      {estadisticas["entradas-total"]}
                    </p>
                  </div>
                  <div className="p-3 bg-purple-100 rounded-circle">
                    <Users className="text-purple-600" size={24} />
                  </div>
                </div>
                <div className="mt-3">
                  <span className="text-muted small">Hoy: </span>
                  <span className="fw-medium small text-dark">
                    {estadisticas["entradas-hoy"]}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <div className="card h-100">
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <p className="text-muted small mb-1">Eventos Activos</p>
                    <p className="h4 fw-bold text-dark mb-0">
                      {estadisticas["eventos-activos"]}
                    </p>
                  </div>
                  <div className="p-3 bg-orange-100 rounded-circle">
                    <Calendar className="text-orange-600" size={24} />
                  </div>
                </div>
                <div className="mt-3 d-none">
                  <span className="text-success fw-medium small">3 nuevos</span>
                  <span className="text-muted small ms-2">esta semana</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Gráficos */}
        <div className="row g-4 mb-4">
          {/* Gráfico de Ventas en Tiempo Real */}
          <div className="col-12 col-lg-6">
            <div className="card h-100">
              <div className="card-header">
                <h5 className="card-title d-flex align-items-center mb-0">
                  <BarChart3 className="me-2" size={20} />
                  Ventas en Tiempo Real
                  <div className="ms-auto d-flex align-items-center">
                    <div
                      className="rounded-circle bg-success me-2 animate-pulse"
                      style={{ width: "8px", height: "8px" }}
                    ></div>
                    <span className="text-muted small">En vivo</span>
                  </div>
                </h5>
              </div>
              <div className="card-body">
                <div style={{ height: "320px" }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={estadisticas["reportes-tiempo-real"]}>
                      <defs>
                        <linearGradient
                          id="colorVentas"
                          x1="0"
                          y1="0"
                          x2="0"
                          y2="1"
                        >
                          <stop
                            offset="5%"
                            stopColor="#8884d8"
                            stopOpacity={0.8}
                          />
                          <stop
                            offset="95%"
                            stopColor="#8884d8"
                            stopOpacity={0}
                          />
                        </linearGradient>
                      </defs>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="time" />
                      <YAxis
                        tickFormatter={(value) =>
                          `$${(value / 1000).toFixed(0)}k`
                        }
                      />
                      <Tooltip
                        formatter={(value, name) => [
                          formatCurrency(value),
                          name === "ventas" ? "Ventas" : "Entradas",
                        ]}
                        labelFormatter={(label) => `Hora: ${label}`}
                      />
                      <Area
                        type="monotone"
                        dataKey="ventas"
                        stroke="#8884d8"
                        fillOpacity={1}
                        fill="url(#colorVentas)"
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>

          {/* Gráfico de Eventos Más Vendidos */}
          <div className="col-12 col-lg-6">
            <div className="card h-100">
              <div className="card-header">
                <h5 className="card-title mb-0">Eventos Más Vendidos</h5>
              </div>
              <div className="card-body">
                <div style={{ height: "320px" }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={estadisticas["eventos-mas-vendidos"]} layout="horizontal">
                      <CartesianGrid strokeDasharray="4 4" />
                      <YAxis
                        dataKey="value"
                        type="number"
                        tickFormatter={(value) =>
                          `$${(value / 1000).toFixed(0)}k`
                        }
                      />
                      <XAxis dataKey="name" type="category" width={120} />
                      <Tooltip
                        formatter={(value) => [formatCurrency(value), "Ventas"]}
                      />
                      <Bar
                        dataKey="value"
                        fill="#8884d8"
                        radius={[0, 4, 4, 0]}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Gráficos Adicionales */}
        <div className="row g-4 mb-4 ">
          {/* Distribución por Tipo de Entrada */}
          <div className="col-12 col-lg-12 mb-4">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-white">
                <h5 className="card-title mb-1">
                  Entradas por Día de Semana
                </h5>
                <p className="card-text text-muted small mb-0">
                  Distribución semanal
                </p>
              </div>
              <div className="card-body">
                <div style={{ height: "300px" }}>
                  <BarChatWeek data={estadisticas["ventas-semana-total"]} />
                </div>
              </div>
            </div>
          </div>

          {/* Métricas Rápidas */}
          <div className="col-12 col-lg-8 d-none">
            <div className="card h-100">
              <div className="card-header">
                <h5 className="card-title mb-0">Métricas del Día</h5>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-6 col-md-3">
                    <div className="text-center p-3 bg-blue-50 rounded">
                      <p className="h4 fw-bold text-blue-600 mb-1">87%</p>
                      <p className="small text-muted mb-0">
                        Ocupación Promedio
                      </p>
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="text-center p-3 bg-green-50 rounded">
                      <p className="h4 fw-bold text-green-600 mb-1">$2,450</p>
                      <p className="small text-muted mb-0">Ticket Promedio</p>
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="text-center p-3 bg-purple-50 rounded">
                      <p className="h4 fw-bold text-purple-600 mb-1">156</p>
                      <p className="small text-muted mb-0">Nuevos Clientes</p>
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="text-center p-3 bg-orange-50 rounded">
                      <p className="h4 fw-bold text-orange-600 mb-1">4.8★</p>
                      <p className="small text-muted mb-0">Rating Promedio</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filtros y Tabla */}
        <div className="card mb-4">
          <div className="card-body p-4">
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h5 className="mb-0">Reportes Detallados</h5>
              <span className="badge bg-secondary">Total: 58,323 reportes</span>
            </div>
            <div className="row g-3 align-items-center">
              {/* Search */}
              <div className="col-12 col-lg-6">
                <div className="position-relative">
                  <Search
                    className="position-absolute top-50 translate-middle-y ms-3 text-muted"
                    size={16}
                  />
                  <input
                    type="text"
                    className="form-control ps-5"
                    placeholder="Buscar reportes..."
                    name="search"
                    onChange={(e) => onChange(e)}
                  />
                </div>
              </div>

              {/* Desktop Filters */}
              <div className="col-12 col-lg-6 d-none d-lg-block">
                <div className="row g-2">
                  <div className="col-6">
                    <select
                      className="form-select"
                      onChange={(e) => {
                        if (e.target.value == "todos") {
                          let params = filter;
                          delete params["filter[eventos.provincia]"];
                          setFilter({ ...params });
                          return fetch(setData, params, "/reportes");
                        }

                        setFilter({
                          ...filter,
                          ["filter[eventos.provincia]"]: e.target.value,
                        });
                        let params = {
                          ...filter,
                          ["filter[eventos.provincia]"]: e.target.value,
                        };

                        fetch(setData, params, "/reportes");
                      }}
                    >
                      <option selected>Seleccionar provincia</option>
                      <option value={"todos"}>Todos</option>
                      {provincias.map((provincia) => {
                        return (
                          <option
                            value={provincia.provincia}
                          >{`${provincia.provincia}`}</option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-6">
                    <select
                      className="form-select"
                      onChange={(e) => {
                        if (e.target.value == "todos") {
                          let params = filter;
                          delete params["filter[status]"];
                          setFilter({ ...params });
                          return fetch(setData, params, "/reportes");
                        }
                        setFilter({
                          ...filter,
                          ["filter[status]"]: e.target.value,
                        });
                        let params = {
                          ...filter,
                          ["filter[status]"]: e.target.value,
                        };
                        fetch(setData, params, "/reportes");
                      }}
                    >
                      <option selected>Seleccionar estado</option>
                      <option value="todos">Todos</option>
                      <option value="ACTIVO">Activo</option>
                      <option value="INACTIVO">Inactivo</option>
                      <option value="REEMBOLSO">Reembolsado</option>
                      <option value="RECHAZADO">Rechazado</option>
                      <option value="LIQUIDADO">liquidado</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Mobile Filter Button */}
              <div className="col-12 d-lg-none">
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => setShowMobileFilters(!showMobileFilters)}
                >
                  <Filter className="me-2" size={16} />
                  Filtros
                </button>
              </div>
            </div>

            {/* Mobile Filters */}
            {showMobileFilters && (
              <div className="row g-3 mt-3 d-lg-none">
                <div className="col-12">
                  <select
                    className="form-select"
                    value={selectedProvince}
                    onChange={(e) => setSelectedProvince(e.target.value)}
                  >
                    <option value="">Seleccionar provincia</option>
                    <option value="buenos-aires">Buenos Aires</option>
                    <option value="cordoba">Córdoba</option>
                    <option value="santa-fe">Santa Fe</option>
                  </select>
                </div>
                <div className="col-12">
                  <select
                    className="form-select"
                    value={selectedState}
                    onChange={(e) => setSelectedState(e.target.value)}
                  >
                    <option value="">Seleccionar estado</option>
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                    <option value="pendiente">Pendiente</option>
                  </select>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Mobile Cards View */}
        <div className="d-lg-none">
          <div className="row g-3 mb-4">
            {reportData.map((report) => (
              <div key={report.id} className="col-12">
                <div className="card">
                  <div className="card-header pb-2">
                    <div className="d-flex align-items-center justify-content-between">
                      <h6 className="mb-0">#{report.id}</h6>
                      <span className="badge bg-success">{report.estado}</span>
                    </div>
                    <p className="text-muted small mb-0">
                      {formatDate(report.fechaCompra)}
                    </p>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <h6 className="fw-semibold text-dark mb-1">
                        {report.evento}
                      </h6>
                      <p className="text-muted small mb-0">
                        Cliente: {report.cliente}
                      </p>
                    </div>
                    <div className="row g-3 small">
                      <div className="col-6">
                        <span className="text-muted">Entrada:</span>
                        <p className="fw-medium mb-0">{report.entrada}</p>
                      </div>
                      <div className="col-6">
                        <span className="text-muted">Cantidad:</span>
                        <p className="fw-medium mb-0">{report.cantidad}</p>
                      </div>
                      <div className="col-6">
                        <span className="text-muted">Total:</span>
                        <p className="fw-bold text-success mb-0">
                          {formatCurrency(report.total)}
                        </p>
                      </div>
                      <div className="col-6">
                        <span className="text-muted">Total + Serv:</span>
                        <p className="fw-bold mb-0">
                          {formatCurrency(report.totalServ)}
                        </p>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center pt-3">
                      <button className="btn btn-outline-primary btn-sm">
                        <Eye className="me-2" size={16} />
                        Ver detalles
                      </button>
                      <div className="dropdown">
                        <button
                          className="btn btn-ghost btn-sm"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <MoreHorizontal size={16} />
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <a className="dropdown-item" href="#">
                              Editar
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              Duplicar
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item text-danger" href="#">
                              Eliminar
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Desktop Table View */}
        <div className="card d-none d-lg-block mb-4">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th style={{ width: "80px" }}>#ID</th>
                  <th style={{ width: "128px" }}>Fecha Compra</th>
                  <th style={{ minWidth: "192px" }}>Evento</th>
                  <th style={{ width: "128px" }}>Cliente</th>
                  <th style={{ width: "96px" }}>Código</th>
                  <th style={{ width: "128px" }}>Entrada</th>
                  <th style={{ minWidth: "192px" }}>Fecha Función</th>
                  <th className="text-end" style={{ width: "96px" }}>
                    Precio
                  </th>
                  <th className="text-center" style={{ width: "80px" }}>
                    Cant.
                  </th>
                  <th className="text-end" style={{ width: "96px" }}>
                    Subtotal
                  </th>
                  <th style={{ width: "80px" }}>Cupón</th>
                  <th className="text-end" style={{ width: "96px" }}>
                    Descuento
                  </th>
                  <th className="text-end" style={{ width: "96px" }}>
                    Total
                  </th>
                  <th className="text-end" style={{ width: "96px" }}>
                    Total + Serv
                  </th>
                  <th style={{ width: "80px" }}>Estado</th>
                  <th style={{ width: "128px" }}>Payway</th>
                  <th className="d-none" style={{ width: "80px" }}>
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.data.map((report) => (
                  <tr key={report.id}>
                    <td className="fw-medium">#{report.id}</td>
                    <td className="small">{formatDate(report.created_at)}</td>
                    <td>
                      <div
                        className="text-truncate-custom"
                        title={report.evento.nombre}
                      >
                        {report.evento.nombre}
                      </div>
                    </td>
                    <td>{report.nombre_cliente}</td>
                    <td>{listarCodigos(report)}</td>
                    <td>{report.entrada.nombre}</td>
                    <td className="small">{report.fecha}</td>
                    <td className="text-end fw-medium">
                      $
                      {parseFloat(report.unidad).toLocaleString("es-AR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="text-center">{report.cantidad}</td>
                    <td className="text-end fw-medium">
                      {parseFloat(
                        report.cantidad * report.unidad
                      ).toLocaleString("es-AR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td>{report.codigo_descuento}</td>
                    <td className="text-end">{`${report.descuento}%`}</td>
                    <td className="text-end fw-bold text-success text-nowrap">
                      {`$
     ${parseFloat(report.cantidad * report.unidad).toLocaleString("es-AR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
     
     `}
                    </td>
                    <td className="text-end fw-bold text-nowrap">
                      {`$
      ${(
                          parseFloat(report.cantidad * report.unidad) +
                          ((report.cantidad * report.unidad) / 100) * report.comision -
                          (((report.cantidad * report.unidad) / 100) * report?.descuento ?? 0)
                        ).toLocaleString("es-AR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })} 
      `}
                    </td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn text-dark border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
                          style={{ borderRadius: "10px" }}
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {report.status}
                        </button>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            <label className="btn m-0 p-0">
                              <i class="text-success mx-1 bi bi-check-circle-fill"></i>
                              Activar
                              <button
                                className="d-none"
                                name="estado"
                                onClick={(event) =>
                                  onClick(event, {
                                    ...report,
                                    status: "ACTIVO",
                                  })
                                }
                              ></button>
                            </label>
                          </li>
                          <li>
                            <label className="btn m-0 p-0">
                              <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                              Inactivo
                              <button
                                className="d-none"
                                name="estado"
                                onClick={(event) =>
                                  onClick(event, {
                                    ...report,
                                    status: "INACTIVO",
                                  })
                                }
                              ></button>
                            </label>
                          </li>
                          <li>
                            <label className="btn m-0 p-0">
                              <i class="text-warning mx-1 bi bi-exclamation-diamond-fill"></i>
                              Reembolsar
                              <button
                                className="d-none"
                                name="estado"
                                onClick={(event) =>
                                  onClick(event, {
                                    ...report,
                                    status: "REEMBOLSO",
                                  })
                                }
                              ></button>
                            </label>
                          </li>
                          <li>
                            <label className="btn m-0 p-0">
                              <i class="text-info mx-1 bi bi-recycle"></i>
                              Rechazado
                              <button
                                className="d-none"
                                name="estado"
                                onClick={(event) =>
                                  onClick(event, {
                                    ...report,
                                    status: "RECHAZADO",
                                  })
                                }
                              ></button>
                            </label>
                          </li>
                          <li>
                            <label className="btn m-0 p-0 d-none">
                              <i class="text-danger mx-1 bi bi-trash"></i>
                              Liquidado
                              <button
                                className="d-none"
                                name="estado"
                                onClick={(event) =>
                                  onClick(event, {
                                    ...report,
                                    status: "LIQUIDADO",
                                  })
                                }
                              ></button>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div
                        className="text-truncate-custom font-monospace small"
                        title={report.codigo}
                      >
                        <label className={`btn me-1 mb-1 `}>
                          {report.codigo}
                          <button
                            className="d-none"
                            name="payway"
                            onClick={(e) => onClick(e, report.codigo)}
                          ></button>
                        </label>
                      </div>
                    </td>
                    <td className="d-none">
                      <div className="dropdown">
                        <button
                          className="btn btn-ghost btn-sm"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <MoreHorizontal size={16} />
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <a className="dropdown-item" href="#">
                              <Eye className="me-2" size={16} />
                              Ver detalles
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              Editar
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              Duplicar
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item text-danger" href="#">
                              Eliminar
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-muted small">
            Mostrando <span className="fw-medium">1</span> a{" "}
            <span className="fw-medium">{data?.per_page ?? 0}</span> de{" "}
            <span className="fw-medium">{data?.total ?? 0}</span> resultados
          </div>

          <div>
            {data.links.map((link) => {
              if (link.label == "&laquo; Previous") {
                return (
                  <label
                    className={`btn btn-outline-dark me-1 ${link.active ? "active" : ""
                      } ${link.url ? "" : "disabled"}`}
                  >
                    <i class="bi bi-chevron-left"></i>
                    ANTERIOR
                    <button
                      className="d-none"
                      name="prev_page"
                      onClick={(e) => onClick(e, data.current_page - 1)}
                    ></button>
                  </label>
                );
              }
              if (link.label == "Next &raquo;") {
                return (
                  <label
                    className={`btn btn-outline-dark ${link.active ? "active" : ""
                      } ${link.url ? "" : "disabled"}`}
                  >
                    SIGUIENTE
                    <i class="bi bi-chevron-right"></i>
                    <button
                      className="d-none"
                      name="next_page"
                      onClick={(e) => onClick(e, data.current_page + 1)}
                    ></button>
                  </label>
                );
              }
              return (
                <label
                  className={`btn btn-outline-dark me-1 ${link.active ? "active" : ""
                    }`}
                >
                  {link.label}
                  <button
                    className="d-none"
                    name="link"
                    onClick={(e) => onClick(e, link.label)}
                  ></button>
                </label>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reportes;
